export interface AtomicWrite {
  table: string;
  id: string;
  run: () => Promise<void>;
  rollback: () => Promise<void>;
}

/** Exécute des écritures séquentielles avec rollback best-effort en cas d'échec. */
export async function runAtomicWrites(writes: AtomicWrite[]): Promise<void> {
  const completed: AtomicWrite[] = [];
  try {
    for (const write of writes) {
      await write.run();
      completed.push(write);
    }
  } catch (error) {
    for (const write of completed.reverse()) {
      try {
        await write.rollback();
      } catch {
        // rollback best-effort : ne masque pas l'erreur initiale
      }
    }
    throw error;
  }
}
